var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-bar",style:({ 'background-image': 'url(' + _vm.backgroundicon + ')' })},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"mb-4 white--text"},[_vm._v(_vm._s(_vm.heading))]),_c('p',{staticClass:"white--text font-weight-regular"},[_vm._v(_vm._s(_vm.subHeading))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }